/* DGA nieuwe huisstijl: video-afspeelknoppen verschijnen als de geest uit de fles zodra ze in beeld komen
   (klein en vaag van onderen, schieten iets te groot op en zakken terug). Na de animatie gaan de klassen eraf,
   zodat de gewone hover (donkerder en groter) weer werkt. Knoppen die al door een andere pagina-JS zijn
   voorbereid (data-pg-genie) worden overgeslagen. Bij 'beweging verminderen' gebeurt er niets.
   Wordt geladen op alle WS2.0-templates (snippets/meta-tags.liquid); stijl in dga-brand-play.css. */
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!('IntersectionObserver' in window))return;
  function run(){
    var els=[].slice.call(document.querySelectorAll('.dga-vk__badge>span,.dgb-case__play')).filter(function(e){return !e.dataset.pgGenie;});
    if(!els.length)return;
    var io=new IntersectionObserver(function(en){
      en.forEach(function(x){
        if(!x.isIntersecting)return;io.unobserve(x.target);
        var el=x.target;el.classList.add('pg-genie-in');
        el.addEventListener('animationend',function done(e){if(e.animationName!=='rf-genie')return;el.removeEventListener('animationend',done);el.classList.remove('pg-genie','pg-genie-in');});
      });
    },{threshold:.6,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el,i){el.dataset.pgGenie='1';el.classList.add('pg-genie');el.style.setProperty('--pg-genie-delay',(0.12+(i%3)*0.08).toFixed(2)+'s');io.observe(el);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
